import { FC, useEffect, useState } from "react";
import { useApiPost } from "../../../../../../hooks";
import { Modal } from "../../../../../TrueUI";
import { isAPITotallyCompleteNoContentResponse } from "../../../../../../utilities/apiFunctions";
import { ModalAddPaymentProps } from "./TypesAddPayment";
import { useSetRecoilState } from "recoil";
import { DefaultPaymentDateAtom } from "../../../BillingAtoms";
import { conditionHasValue } from "../../../../../../utilities/conditionalSupportFunctions";
import { AddPaymentProps } from "./TypesAddPayment";
import FormPaymentAndBalanceTableWrapper from "./FormPaymentAndBalanceTableWrapper";
import { defaultPaymentData } from "./ModalAddPaymentUtil";

const ModalAddPayment: FC<ModalAddPaymentProps> = ({
  insuredId,
  showModal,
  isOpenModal,
  accountTableData,
  readOnly = false,
  billingPaymentId = null,
}) => {
  const [paymentData, setPaymentData] = useState<AddPaymentProps>({
    payment: { insuredId: insuredId },
    billingTransactionDataList: [],
  });

  const [onLoadData, setOnLoadData] = useState<boolean>(false);

  const [errorDetails, setErrorDetails] = useState<any>();

  const {
    responsePost: responseSaveData,
    dispatchPost: dispatchSaveData,
    validatorErrorResponse,
  } = useApiPost<any>(`api/PaymentActivity/SaveNewPayment`, {
    ...paymentData.payment,
    billingTransactionDataList: paymentData.billingTransactionDataList,
  });

  const setDefaultPaymentDateAtomValue = useSetRecoilState(
    DefaultPaymentDateAtom
  );

  useEffect(() => {
    if (validatorErrorResponse) {
      setErrorDetails(validatorErrorResponse.errorDetails);
    }
    if (isAPITotallyCompleteNoContentResponse(responseSaveData)) {
      const data = defaultPaymentData(
        insuredId,
        paymentData?.payment?.bankAccountId
      );
      setPaymentData({ payment: data });
      isOpenModal(false);
    }
  }, [responseSaveData]);

  useEffect(() => {
    if (conditionHasValue(paymentData?.payment?.paymentDate)) {
      if (onLoadData) {
        setPaymentData({
          ...paymentData,
          payment: {
            ...paymentData.payment,
            dateReceived: paymentData?.payment?.paymentDate,
            postmarkDate: paymentData?.payment?.paymentDate,
          },
        });
        setDefaultPaymentDateAtomValue(
          paymentData?.payment?.paymentDate ?? null
        );
      } else setOnLoadData(true);
    }
  }, [paymentData?.payment?.paymentDate]);

  const onSaveEvent = () => {
    setErrorDetails(null);
    dispatchSaveData();
  };

  const onCancelEvent = () => {
    isOpenModal(false);
    setOnLoadData(false);
  };

  const onCloseEvent = () => {
    setErrorDetails(null);
    setPaymentData({ payment: defaultPaymentData(insuredId) });
    setOnLoadData(false);
  };

  return (
    <Modal
      id={"add-payment"}
      title={"New Payment"}
      open={showModal}
      showCloseButton={true}
      deleteEvent={undefined}
      showCancelTextButton={true}
      saveEvent={onSaveEvent}
      cancelEvent={onCancelEvent}
      closeEvent={onCloseEvent}
      saveOverrideLabel={billingPaymentId ? "SAVE CHANGES" : "SAVE"}
      cancelButtonWithConfirmation
      showExtraButtons={billingPaymentId ? true : false}
      extraButtons={[
        {
          textOnButton: "RETURN ITEM",
          name: "return",
          onClick: () => alert("Future feature"),
        },
      ]}
    >
      <FormPaymentAndBalanceTableWrapper
        insuredId={insuredId}
        paymentData={paymentData}
        setPaymentData={setPaymentData}
        errorMessages={errorDetails}
        accountTableData={accountTableData}
        readOnly={readOnly}
        billingPaymentId={billingPaymentId}
      />
    </Modal>
  );
};

export default ModalAddPayment;
